import { render } from "./HelpDrawer.vue?vue&type=template&id=42e88c26&ts=true"
import script from "./HelpDrawer.vue?vue&type=script&lang=ts"
export * from "./HelpDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/thomaswang/Workspace/Latipay/FlashFxUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__